import { call, put } from "redux-saga/effects";
import {
  getFavorites,
  addFavorite,
  removeFavorite,
  getFavoritedStores,
} from "@Api/favoritesApi.js";
import actions from "@Src/redux/rootActions";

const {
  fetchFavoritesSuccess,
  fetchFavoritesFailure,
  addFavoriteSuccess,
  addFavoriteFailure,
  removeFavoriteSuccess,
  removeFavoritedStore,
  removeFavoriteFailure,
  fetchFavoritedStoresSuccess,
  fetchFavoritedStoresFailure,
} = actions.favorites;

export function* doGetFavorites() {
  try {
    const response = yield call(getFavorites);

    yield put(fetchFavoritesSuccess(response));
  } catch (error) {
    console.error(error);

    yield put(fetchFavoritesFailure(error));
  }
}

export function* doAddFavorite(action) {
  try {
    const response = yield call(addFavorite, action.payload);

    yield put(addFavoriteSuccess(response));
  } catch (error) {
    console.error(error);

    yield put(addFavoriteFailure(error));
  }
}

export function* doRemoveFavorite(action) {
  try {
    const favId = action.payload.favoriteId;
    const brandId = action.payload.brandId;
    const response = yield call(removeFavorite, favId);

    yield put(removeFavoriteSuccess(response));
    yield put(removeFavoritedStore(brandId));
  } catch (error) {
    console.error(error);

    yield put(removeFavoriteFailure(error));
  }
}

export function* doFavsLookup(action) {
  try {
    const response = yield call(getFavoritedStores, action.payload);

    yield put(fetchFavoritedStoresSuccess(response));
  } catch (error) {
    console.error(error);

    yield put(fetchFavoritedStoresFailure(error));
  }
}
